// wa-floating-button.js
// 1) El botón se desplaza levemente al hacer scroll, como si flotara, y vuelve suavemente.
// 2) Tras unos segundos aparece un globo "¿Dudas con una talla?" (una sola vez por sesión).
(function () {
  const btn = document.getElementById('wa-float');
  if (!btn) return;

  const reduce = false;

  if (!reduce) {
    // En desktop el scroll vive dentro de .page-wrapper; en celular, en window
    function getY() {
      const pw = document.querySelector('.page-wrapper');
      if (pw && pw.scrollHeight > pw.clientHeight + 1) {
        const oy = window.getComputedStyle(pw).overflowY;
        if (oy === 'auto' || oy === 'scroll') return pw.scrollTop;
      }
      return window.scrollY;
    }

    let lastY = getY();
    let ticking = false;

    function onScroll() {
      const currentY = getY();
      const delta = currentY - lastY;
      lastY = currentY;

      const offset = Math.max(-14, Math.min(14, -delta * 1.4));
      btn.style.transition = 'none';
      btn.style.transform = `translateY(${offset}px)`;

      if (!ticking) {
        ticking = true;
        requestAnimationFrame(() => {
          btn.style.transition = 'transform 0.35s cubic-bezier(.22,1,.36,1)';
          btn.style.transform = 'translateY(0px)';
          ticking = false;
        });
      }
    }

    document.addEventListener('scroll', onScroll, { capture: true, passive: true });
  }

  // ---- Globo de ayuda ----
  const tip = document.getElementById('wa-tip');
  const tipClose = document.getElementById('wa-tip-close');
  if (!tip) return;

  const KEY = 'pm_wa_tip_seen';
  let seen = false;
  try { seen = !!sessionStorage.getItem(KEY); } catch (e) {}
  if (seen) return;

  function hideTip() {
    tip.classList.remove('is-on');
    try { sessionStorage.setItem(KEY, '1'); } catch (e) {}
  }

  setTimeout(function () { tip.classList.add('is-on'); }, 9000);
  setTimeout(hideTip, 9000 + 7000);
  if (tipClose) tipClose.addEventListener('click', hideTip);
  btn.addEventListener('click', hideTip);
})();